import { AppDispatch } from "../../store";
import { siteContextRequest } from "../../redux/siteContextRequest";
import config from "../../config";

type DateYYYYMMDD = string;

interface IPrescan {
  detailedDemDiffTilesPath: string | null;
  doneDate: DateYYYYMMDD;
  elevationMapTilesPath: string;
  isExpired: boolean;
  orthophotoTilesPath: string;
}

export const fetchPrescan =
  (customerId: string, siteId: string) =>
  async (dispatch: AppDispatch): Promise<IPrescan> => {
    const response = await dispatch(
      siteContextRequest(customerId, siteId, {
        method: "GET",
        url: `${config.endpoints.backofficeApi}/${customerId}/${siteId}/latest-prescan`,
      }),
    );

    // TODO: add validation, e.g. using JSON schema

    return response.data.prescan;
  };

interface IMaidenScan {
  elevationMapTilesPath: string;
  orthophotoTilesPath: string;
}

export const fetchMaidenScan =
  (customerId: string, siteId: string) =>
  async (dispatch: AppDispatch): Promise<IMaidenScan> => {
    const response = await dispatch(
      siteContextRequest(customerId, siteId, {
        method: "GET",
        url: `${config.endpoints.backofficeApi}/${customerId}/${siteId}/maiden-scan`,
      }),
    );
    return response.data.maidenScan;
  };
